import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { App, Button, Form, Input, Typography } from 'antd';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthentificationService from '../../services/authentification/AuthentificationService';
import '../Login/Login.css';
import loginBackground from './../../images/login.svg';

const Login: React.FC = () => {
  const [errorMessageDisplayed, setErrorMessageDisplayed] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleNameChange = debounce((value: string) => setName(value), 100);
  const handlePasswordChange = debounce((value: string) => setPassword(value), 100);
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const { message } = App.useApp();

  const handleResponse = (data: any) => {
    if (data?.errors?.length > 0) {
      data?.errors?.forEach((item: string) => {
        message.error(item);
        return;
      });
    }
    navigate('/home');
  };

  const onFinish = () => {
    if (!name || !password) {
      if (!errorMessageDisplayed) {
        message.error(!name ? 'Introdu numele!' : 'Introdu parola!');
        setErrorMessageDisplayed(true);
        setTimeout(() => {
          setErrorMessageDisplayed(false);
        }, 2000);
      }
      return;
    }

    AuthentificationService.login({ email: name, password }).then((data) => {
      handleResponse(data);
    });
  };

  return (
    <div className='login-container'>
      <img src={loginBackground} alt='Background' className='background-image' />
      <div className='login-form-container'>
        <Form form={form} className='form' onFinish={onFinish}>
          <Typography.Title level={5} className='typography'>
            Log In
          </Typography.Title>
          <Form.Item name='name'>
            <Input placeholder='Nume' onChange={(e) => handleNameChange(e.target.value)} />
          </Form.Item>
          <Form.Item name='password'>
            <Input.Password
              placeholder='Parola'
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              onChange={(e) => handlePasswordChange(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit' className='button' block>
              Conectează-te
            </Button>
          </Form.Item>
          <Typography.Title level={5} className='typography'>
            Produced by SIMPLY AGENCY SRL
          </Typography.Title>
        </Form>
      </div>
    </div>
  );
};

export default Login;
